import React, {useEffect, useState} from 'react';
import {useQuery} from "@apollo/react-hooks";
import {notify} from "../../utils/notify";
import {Select} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    select: {
        '& .MuiPopover-paper': {
            zIndex: 99999,
        }
    }
}));

const ChooseFromChoices = props => {
    const classes = useStyles();
    const [choices, setChoices] = useState();
    const [value, setValue] = useState(props.value);

    const {error: getChoicesError, data: getChoicesData} = useQuery(props.choicesQuery);

    useEffect(() => {
        if (getChoicesError) notify('getChoicesError', 'error', getChoicesError.message);
    }, [getChoicesError]);

    useEffect(() => {
        if (getChoicesData) {
            Object.keys(getChoicesData).forEach(key => {
                const data = getChoicesData[key];
                if (data.choices) setChoices(data.choices);

            });
        }
    }, [getChoicesData]);

    const handleChange = e => {
        setValue(e.target.value);
        props.onChange(e.target.value);
    };

    return (
        <>
            {choices && (
                <>
                    {props.titleChoice && <InputLabel id="label-choices" required>
                        {props.titleChoice}
                    </InputLabel>}
                    <Select
                        className={classes.select}
                        required={props.required}
                        id="choices"
                        name="choices"
                        labelid="label-choices"
                        fullWidth
                        size="small"
                        value={value}
                        onChange={handleChange}
                    >
                        {choices.map((choice, index) => {
                            return <MenuItem key={index} value={choice}>{choice}</MenuItem>
                        })}
                    </Select>
                </>
            )}
        </>
    );
};

export default ChooseFromChoices
